/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from "../../utility/axios";

// state
import {
  setUpdate,
  // setServiceRequestLoading,
  setServiceRequest,
  setServiceRequests,
  setLoading,
  setTotal,
  createRequestPrice as createRequestPriceState,
  updateRequestPrice as updateRequestPriceState,
} from "../../store/slices/request";
// import { save_document } from "./upload";
import { AppDispatch } from "../../store/store";
import {
  ICreateRequestPrice,
  IPrice,
  IUploadDocument,
  IUpdateRequestPrice,
  IViewRequestItem,
  IResponseRequests,
} from "../../store/types/request";
import { toast } from "sonner";
import { IApiResponse } from "@/src/store/types/api-response";
import { getErrorMessage } from "../apiError";

const requestEndpoint = "/api/v1/admin/service-requests";
const requestPriceEndpoint = "/api/v1/admin/service-request-prices";

export const get_service_requests = async (
  dispatch: AppDispatch,
  limit: number,
  offset: number,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get<IApiResponse<IResponseRequests>>(
      requestEndpoint,
      {
        params: { limit, offset },
      },
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "Unable to load service requests.");
    }

    dispatch(setServiceRequests(response.data.data));
    dispatch(setTotal(response.data.data.total));
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to load service requests."));
  } finally {
    dispatch(setLoading());
  }
};

export const get_request = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get<IApiResponse<IViewRequestItem>>(
      `${requestEndpoint}/${id}`,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "Unable to load request details.");
    }

    const { data } = response.data;
    dispatch(setServiceRequest(data));
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to load request details."));
  } finally {
    dispatch(setLoading());
  }
};

export const create_service_request = async (
  formData: any,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/create-service", formData);
    if (response.data) {
      toast.success(response.data.message || "Request created successfully.");
    }
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to create request."));
  } finally {
    dispatch(setLoading());
  }
};

export const edit_service_request = async (
  data: any,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.put(`/edit-training`, data);
    if (response.data) {
      toast.success(response.data.message || "Request updated successfully.");
    }
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to update request."));
  } finally {
    dispatch(setLoading());
  }
};

export const cancel_request = async (dispatch: AppDispatch) => {
  try {
    const response = await axiosInstance.patch("/update-status");

    // dispatch(setRequest(response.data));
    toast.success(response.data.message || "Request updated successfully.");
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to update request."));
  }
};

export const upload_document = async (
  dispatch: AppDispatch,
  data: IUploadDocument,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post(
      "v1/create-document-service-request",
      data,
    );

    toast.success(response?.data?.message || "Document uploaded successfully.");
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to upload document."));
  } finally {
    dispatch(setUpdate());
  }
};

export const get_total_request = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/v1/get-total-request");

    const { data } = response.data;
    dispatch(setTotal(data));
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to load request totals."));
  } finally {
    dispatch(setLoading());
  }
};

// export const get_all_request_histogram = async (dispatch: AppDispatch) => {
//   dispatch(setLoading());
//   try {
//     const response = await axiosInstance.get("/v1/get-all-request-chart");

//     const { data } = response.data;
//     dispatch(setBarGraph(data));
//   } catch (error) {
//     if (isAxiosError(error)) console.log("Error:", error?.response?.data);
//   }
//   dispatch(setLoading());
// };

// export const get_statuses = async (dispatch: AppDispatch) => {
//   try {
//     const response = await axiosInstance.get("/v1/request-statuses");

//     const { data } = response;
//     dispatch(setRequestStatus(data));
//   } catch (err) {
//     if (isAxiosError(err)) return false;
//   }
// };

//service price request.

export const add_request_price = async (
  dispatch: AppDispatch,
  data: ICreateRequestPrice,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post<IApiResponse<IPrice>>(
      requestPriceEndpoint,
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "Unable to create price.");
    }
    const { message, data: payload } = response.data;

    dispatch(createRequestPriceState(payload));

    toast.success(message || "Price created successfully.");
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to create price."));
  } finally {
    dispatch(setUpdate());
  }
};

export const update_request_price = async (
  dispatch: AppDispatch,
  data: IUpdateRequestPrice,
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.patch<IApiResponse<IPrice>>(
      requestPriceEndpoint,
      data,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || "Unable to update price.");
    }
    const { message, data: payload } = response.data;

    dispatch(updateRequestPriceState(payload));

    toast.success(message || "Price updated successfully.");
  } catch (error) {
    toast.error(getErrorMessage(error, "Unable to update price."));
  } finally {
    dispatch(setUpdate());
  }
};
